import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FootballTeamManager } from "../../../../../../commons/models/football/football-team-manager";
import { EnsueCollection } from "../../../../../../ensue-react-system/utilities/ensue-collection";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";

export interface IManageTeamManagersState {
  manageTeamManagersList: EnsueCollection<FootballTeamManager>;
  manageTeamManagersListStatus: StatusEnum;
}

export interface IManageTeamManagersOption {
  teamId: number;
  urlParams?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
  };
}

const initialState: IManageTeamManagersState = {
  manageTeamManagersList: new EnsueCollection<FootballTeamManager>(),
  manageTeamManagersListStatus: StatusEnum.Idle,
};

export const fetchManageTeamManagerList = createAsyncThunk(
  "manage/teamManagerList",
  async (options: IManageTeamManagersOption, thunkAPI) => {
    try {
      const manageTeamManagersList = await manageFootballTeamService.getTeamManagers(options.teamId, options.urlParams);
      return manageTeamManagersList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageTeamManagerListSlice = createSlice({
  name: "teamManagerAdd",
  initialState: initialState,
  reducers: {
    cleanUpManageTeamManagers(state) {
      state.manageTeamManagersList = new EnsueCollection<FootballTeamManager>();
      state.manageTeamManagersListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageTeamManagerList.pending, (state) => {
        state.manageTeamManagersListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageTeamManagerList.fulfilled,
        (state, action: PayloadAction<EnsueCollection<FootballTeamManager>>) => {
          state.manageTeamManagersListStatus = StatusEnum.Succeeded;
          state.manageTeamManagersList = action.payload;
        }
      )
      .addCase(fetchManageTeamManagerList.rejected, (state) => {
        state.manageTeamManagersListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpManageTeamManagers } = manageTeamManagerListSlice.actions;
export default manageTeamManagerListSlice.reducer;
